var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"filter-dropdown",attrs:{"options":_vm.data,"placeholder":("Select " + _vm.title),"label":"title"},on:{"input":_vm.changeFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }